/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description DownloadInvoice button
 */

import { Button } from 'antd';

import { isFailedPayment, shouldRetryPayment } from 'utils/admin/subscriptions';
import RetryPayment from './RetryPayment';

export interface IProps {
	isLatest: boolean;
	invoice?: Subscriptions.InvoiceModel;
}

/**
 * DownloadInvoice button
 */
const DownloadInvoice: React.FC<IProps> = ({ invoice, isLatest }) => {
	const isFailed = isFailedPayment(invoice);
	const fileURL = invoice?.file_url;

	// retry payment
	if (shouldRetryPayment(isLatest, invoice)) {
		return <RetryPayment externalId={invoice?.external_id} />;
	}

	// download invoice
	if (!isFailed && fileURL) {
		return (
			<Button
				color='default'
				onClick={() => {
					globalThis.open(fileURL);
				}}
			>
				{'View / Download'}
			</Button>
		);
	}

	// invoice is still generating
	return null;
};

export default DownloadInvoice;
